// Service Worker Registration
export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl, { updateViaCache: 'none' })
      .then((registration) => {
        console.log('[PWA] Service Worker registered:', registration.scope);

        // Check for an update every time the tab becomes visible
        // (catches the case where the user keeps a tab open during a deploy).
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        });

        // Auto-update on every page navigation (covers SPA route changes
        // and re-opens after deploys).
        registration.update().catch(() => {});

        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // A new SW is waiting. Tell it to skipWaiting, then reload
              // the page so the user gets the new bundle WITHOUT manual
              // cache clear. This is the post-deploy fix.
              console.log('[PWA] New version available — applying…');
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          };
        };

        // When the new SW takes control, reload exactly once so the
        // freshly-served index.html (which references the new bundle
        // hashes) replaces the running old one.
        let reloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      })
      .catch((error) => {
        console.error('[PWA] Service Worker registration failed:', error);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Service Worker unregistration failed:', error);
      });
  }
}

// Request push notification permission
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('[PWA] This browser does not support notifications');
    return false;
  }
  
  const permission = await Notification.requestPermission();
  
  if (permission === 'granted') {
    console.log('[PWA] Notification permission granted');
    return true;
  }
  
  console.log('[PWA] Notification permission denied');
  return false;
}

// Subscribe to push notifications
export async function subscribeToPush(vapidPublicKey) {
  try {
    const registration = await navigator.serviceWorker.ready;
    
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });
    
    console.log('[PWA] Push subscription:', subscription);
    return subscription;
  } catch (error) {
    console.error('[PWA] Push subscription failed:', error);
    return null;
  }
}

// Helper function for VAPID key conversion
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  
  return outputArray;
}

// Check if app is installed
export function isAppInstalled() {
  // Check if running in standalone mode (installed PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  // iOS Safari standalone check
  if (window.navigator.standalone === true) {
    return true;
  }
  return false;
}

// Check if install prompt is available
export function canInstall() {
  return window.deferredPrompt !== undefined;
}
